import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { LoginService } from '../../auth/login.service';
import { safeReturnUrl } from '../../auth/safe-return-url';
import { crmHomeRoute } from '../utils/crm-home-route';

export const LoginGuard: CanActivateFn = (route, _state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const returnUrl = safeReturnUrl(route.queryParamMap?.get('returnUrl'));

  // A fresh tab may have a valid cookie without any cached profile.
  // Prove the server session before showing login, regardless of Remember.
  // Email links (for example /profile/approvals) must come back here, not the hub.
  const landing = () =>
    returnUrl
      ? router.parseUrl(returnUrl)
      : router.createUrlTree([crmHomeRoute(p => loginService.hasAnyPermission(p))]);

  return loginService.fetchCurrentUser().pipe(
    map(() => landing()),
    // A temporary /me outage must not strand a known session on the login form.
    // Definitive 401s already cleared the cache in AuthInterceptor.
    catchError(() => of(loginService.hasUsableSession() ? landing() : true))
  );
};
